import { UserAddOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { Outlet, useLoaderData, useNavigate } from 'react-router-dom';
import { getTemplates } from '../../api/settings';
import { Page } from '../../components/page';
import { InfiniteTable } from '../../components/table';
import useFetch from '../../hooks/use-fetch.js';
import { generateRouteUrl } from '../../library/constants/routes.js';
import { TemplateColumns } from '../../library/constants/tableColumns';

function TextTemplates(props) {
  const { title } = props;
  const initialData = useLoaderData()
  const [list, hasMore, isLoading, , {
    setSort,
    loadMore
  }] = useFetch({ initialData })
  const navigate = useNavigate()

  return (
    <Page
      className='users'
      title={title}
      summary={initialData?.meta?.totalCount ? `(${initialData?.meta?.totalCount} Records)` : '(No Records)'}
      header={(
        <>
          <div></div>
          <Button type="primary" onClick={() => { navigate(generateRouteUrl('TextTemplateCreate')) }} icon={<UserAddOutlined />}>Add new Template</Button>
        </>
      )}
    >
      <InfiniteTable
        columns={TemplateColumns}
        scroll={{ x: '100%' }}
        dataSource={list}
        rowKey="id"
        isLoading={isLoading}
        onChange={setSort}
        hasMore={hasMore}
        loadMore={loadMore}
        onRow={template => ({
          onClick: () => {
            navigate(generateRouteUrl('TemplateDetails', {
              templateId: template.id
            }))
          }
        })}
      />
      <Outlet />
    </Page>
  )
}

TextTemplates.Loader = async ({ request }) => {
  const url = new URL(request.url);
  const fieldTypeId = parseInt(url.searchParams.get("filter_type_id"));
  const payload = {}
  if (fieldTypeId && !isNaN) {
    payload.field_type_id = fieldTypeId
  }
  const { data, meta } = await getTemplates(payload).catch(() => [])
  return { data, meta }
}

TextTemplates.propTypes = {
  title: PropTypes.string,
}

export default TextTemplates
